<script lang="ts">
	import { generateUUID } from '#lib/helper/uuid.js';
	import ContextualPopin from '#lib/modern/ContextualPopin.svelte';
	import Svg from '#lib/svg/svg.svelte';
	import type { Icon } from '#lib/types/icons.js';
	import type { Snippet } from 'svelte';

	interface Props {
		icon: Icon;
		iconSizeClasses?: string;
		color?: string;
		title?: string;
		displayTitle?: boolean;
		className?: string;
		children?: Snippet;
	}

	let {
		icon,
		iconSizeClasses = '',
		color = '',
		title = '',
		displayTitle = false,
		className = 'truncate',
		children
	}: Props = $props();

	let show = $state(false);

	let id = generateUUID();

	let debounce: NodeJS.Timeout;
	function debounceShow() {
		clearTimeout(debounce);
		debounce = setTimeout(() => {
			show = true;
		}, 200);
	}

	function hide() {
		clearTimeout(debounce);
		show = false;
	}
</script>

<div
	onmouseenter={debounceShow}
	onmouseleave={hide}
	ontouchstart={() => (show = true)}
	ontouchend={hide}
	role="complementary"
	id="img-tooltip-hover-{id}"
	class="flex items-center gap-2 {color}"
>
	<Svg className={iconSizeClasses + ' flex-none'} src={icon} />
	{#if displayTitle}
		<span class={className}>{title}</span>
	{/if}
	{@render children?.()}
</div>

{#if show && !displayTitle}
	<ContextualPopin
		targetElement="img-tooltip-hover-{id}"
		padding="p-2"
		align="left"
		valign="bottom"
	>
		<div class="flex items-center gap-2 text-sm flex-no-wrap text-nowrap">
			<Svg src={icon} className="w-4 h-4 flex-none" />
			{title}
		</div>
	</ContextualPopin>
{/if}
